<div class="drag-container small" ngDraggable [inBounds]="true" [handle]="DragItem" *ngIf="showPopUp">
    <div class="table-drag" #DragItem></div>
    <div class="drag-wrap">
        <div class="drag-header">
            <div class="head-wrap">
                <span class="iconB-draggable"></span>
                <h4 class="drag-title">Tour Guide</h4>
            </div>
            <button type="button" class="close" aria-label="Close" (click)="pressCloseButton()">
                <i _ngcontent-c46="" class="icon icon-cira"></i>
      </button>
        </div>
        <div class="drag-body">
            <div class="input-tour-wrap">
                <input type="text" class="form-control c-form-control c-icon-control" [(ngModel)]="searchTour" (ngModelChange)="searchFunction(searchTour)" placeholder="Search.." />
            </div>
            <i class="icon-search c-form-control-icon" *ngIf="!searchTour"></i>
            <span class="icon-cira clear-text" (click)="searchTour=''; searchFunction(searchTour)" *ngIf="searchTour"></span>
            <br>
            <div class="scroll-tour-container">
                <ng-scrollbar class="scroll">
                    <li class="tour-data" *ngFor="let result of searchResults"><i class="iconB-guide-tour"></i>
                        <a (click)="getTour(result._id)">{{ result.tour_name }}</a></li>

                </ng-scrollbar>
            </div>
        </div>
    </div>
</div>